import { render } from "./BuildingCardComponent.vue?vue&type=template&id=69777642&scoped=true"
import script from "./BuildingCardComponent.vue?vue&type=script&lang=js"
export * from "./BuildingCardComponent.vue?vue&type=script&lang=js"

import "./BuildingCardComponent.vue?vue&type=style&index=0&id=69777642&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69777642"]])

export default __exports__